import React from 'react';
import { CarouselInjectedProps } from 'pure-react-carousel';

export interface ImageWatcherProps {
  images: string[];
  alwaysHonorCurrentSlide?: boolean;
  children?: React.ReactNode;
  filterID?: string;
  isVisualNav?: boolean;
}

/*
 * This component receives the images array that is used to render all of the slides.
 * Since the CarouselProvider and the Slider component don't know about the images
 * array, we are using this to watch for changes to the array, when the array changes
 * we set the currentSlide back to 0. Since the Carousel.jsx component is outside of
 * CarouselProvider it is unable to update the carouselStore state and can only set the initial
 * slide state in carouselProvider.
 *
 * NOTE: This must remain a class-based component because Pure React Carousel
 * is currently class-based.  The WithStore() higher order component in Pure
 * React Carousel passes a reference to the component. React
 * complains that you can't pass references from a class-based component to a
 * functional component.  Therefore, this must remain a class for now.
 */
class ImageWatcher extends React.Component<
  ImageWatcherProps & CarouselInjectedProps
> {
  componentDidUpdate(prevProps: Readonly<ImageWatcherProps>): void {
    const { alwaysHonorCurrentSlide, isVisualNav, filterID } = this.props;
    const isNewImageSet =
      JSON.stringify(prevProps.images) !== JSON.stringify(this.props.images);
    const isNewFilterCategory = prevProps.filterID !== filterID;

    if (isVisualNav && !isNewFilterCategory) return;

    if (alwaysHonorCurrentSlide || isNewImageSet) {
      this.props.carouselStore.setStoreState({ currentSlide: 0 });
    }
  }
  render() {
    return null;
  }
}

export default ImageWatcher;
